window.IVCInit = function (trackId) {
  var track = document.getElementById(trackId);
  if (!track) {
    return;
  }
  if (track.dataset.ivcReady === 'true') {
    return;
  }
  track.dataset.ivcReady = 'true';

  var cards = track.querySelectorAll('.ivc-card');

  function tryPlay(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {});
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        var video = entry.target.querySelector('.ivc-video');
        if (!video) {
          continue;
        }
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          tryPlay(video);
        } else {
          video.pause();
        }
      }
    },
    { threshold: [0, 0.5, 1] }
  );

  cards.forEach(function (card) {
    observer.observe(card);
  });

  var wrapEl = track.closest('.ivc-carousel-wrap');
  if (wrapEl) {
    var leftBtn = wrapEl.querySelector('.ivc-arrow-left');
    var rightBtn = wrapEl.querySelector('.ivc-arrow-right');
    var scrollAmount = 260;

    if (leftBtn) {
      leftBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
    if (rightBtn) {
      rightBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  }
};

// Global, document-level delegated handler for mute buttons.
// Attached once, survives any later re-rendering of the carousel's
// own DOM, since it never depends on a specific track/button node.
if (!window.__ivcMuteHandlerAttached) {
  window.__ivcMuteHandlerAttached = true;
  document.addEventListener('click', function (e) {
    var muteBtn = e.target.closest('.ivc-mute-btn');
    if (!muteBtn) {
      return;
    }
    var card = muteBtn.closest('.ivc-card');
    if (!card) {
      return;
    }
    var video = card.querySelector('.ivc-video');
    var wrap = card.querySelector('.ivc-video-wrap');
    if (!video) {
      return;
    }
    video.muted = !video.muted;
    if (wrap) {
      wrap.classList.toggle('ivc-is-unmuted', !video.muted);
    }
  });
}